import {RefinementListProps, useRefinementList} from "react-instantsearch";
import React from "react";
import {useState} from "@wordpress/element";
import {chevronDown, chevronUp, Icon} from "@wordpress/icons";


type CustomRefinementListProps = {
    labelsToExclude?: string[];
} & RefinementListProps;

export default function CustomRefinementList(props: CustomRefinementListProps) {
    const [showFilter, setShowFilter] = useState(false)
    const {items, refine} = useRefinementList(props);

    const labelsToExclude = props.labelsToExclude ?? [];
    const filteredItems = items.filter(
        item => !labelsToExclude.includes(item.label)
    );

    const hasItems = filteredItems.length > 0;

    return (
        <div className="refinement-list">
            <h4 className="refinement-list__header" onClick={() => setShowFilter(!showFilter)}>
                <div className="refinement-list__title">{props.title}</div>
                <div className="refinement-list__toggle">
                    <button className="refinement-list__button" onClick={() => setShowFilter(!showFilter)}>
                        {showFilter ? (<Icon icon={chevronUp}/>) : (<Icon icon={chevronDown}/>)}
                    </button>
                </div>
            </h4>
            {showFilter && <div>
                {hasItems ? (
                    <ul className="refinement-list__items">
                        {filteredItems.map((item) => (
                            <li key={item.label} className="refinement-list__item">
                                <label className="refinement-list__label">
                                    <input
                                        type="checkbox"
                                        checked={item.isRefined}
                                        onChange={() => refine(item.value)}
                                    />
                                    {item.label} <span className="refinement-list__count">({item.count})</span>
                                </label>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <span className="refinement-list__empty">Aucun critère de filtrage</span>
                )}
            </div>}


        </div>
    );

}